import styled from '@emotion/styled';
import { Container, SectionText, SectionTitle } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const PageWrapper = styled.div`
  background: #f8f8f8;
`;

export const TopWrapper = styled.div`
  background: ${(props) => props.theme.color.blue.default};
  position: relative;
  overflow: hidden;
`;

export const TopContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 300px;
`;

export const TopDecoration = styled.img`
  width: 1324px;
  height: 1321px;
  top: 32px;
  left: -630px;
  position: absolute;
`;

export const TopSeparator = styled.img`
  width: 100%;
  height: auto;
  left: 0;
  right: 0;
  bottom: -2px;
  z-index: 1;
  position: absolute;
`;

export const TopTitle = styled(SectionTitle)`
  ${responsiveFontSize(52, 7)}
  color: ${(props) => props.theme.color.light.default};
  ${mediaQuery('small')} {
    text-align: center;
  }
`;

export const TopImagesContainer = styled.div`
  display: flex;
  align-items: top;
  justify-content: center;
  max-height: 780px;
  margin-top: -80px;
  margin-left: 30px;

  ${mediaQuery('small')} {
    display: none;
  }
`;

export const TopImagesContainerSection = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(even) {
    margin-top: -110px;
  }

  ${mediaQuery('desktop')} {
    &:last-child {
      display: none;
    }
  }

  ${mediaQuery('medium')} {
    &:first-child {
      display: none;
    }
  }
`;

export const TopImageWrapper = styled.div`
  padding: 16px;
`;

export const TopImage = styled.img`
  width: 220px;
  height: 220px;
  border-radius: 100%;
  object-fit: cover;
`;

export const MissionWrapper = styled.div`
  text-align: center;
  padding: 75px 0;
`;

export const MissionTitle = styled(SectionTitle)`
  max-width: 800px;
  margin: auto;
  margin-bottom: 25px;
`;

export const MissionCardContainer = styled.div`
  display: flex;
  align-items: strech;
  justify-content: center;
  margin-top: 100px;
  ${mediaQuery('tablet')} {
    flex-direction: column;
  }
`;

export const MissionCard = styled.div`
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 25px;
  text-align: left;
  ${mediaQuery('tablet', 'min')} {
    &:not(:last-child) {
      margin-right: 50px;
    }
  }
  ${mediaQuery('tablet')} {
    &:not(:last-child) {
      margin-bottom: 85px;
    }
  }
`;

export const MissionCardImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 100%;
  margin-top: -75px;
  margin-bottom: 15px;
`;

export const MissionCardTitle = styled.div`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color.purple.default};
  ${responsiveFontSize(24, 1)}
  margin-bottom: 15px;
`;

export const ValuesWrapper = styled.div`
  background: ${(props) => props.theme.color.blue.default};
  margin: 150px 0;
  padding: 30px 0;
  position: relative;
  text-align: center;
  ${mediaQuery('tablet')} {
    margin: 75px 0;
  }
`;

export const ValuesTitle = styled(SectionTitle)`
  color: ${(props) => props.theme.color.light.default};
  margin-bottom: 30px;
`;

export const ValuesCardContainer = styled.div`
  display: flex;
  align-items: strech;
  justify-content: center;
  ${mediaQuery('medium')} {
    flex-direction: column;
    align-items: center;
  }
`;

export const ValuesCardWrapper = styled.div`
  padding: 10px;
  padding-top: 0;
  width: ${100 / 3}%;
  ${mediaQuery('medium')} {
    width: 100%;
    max-width: 400px;
  }
`;

export const ValuesCard = styled.div`
  height: 100%;
  background: ${(props) => props.theme.color.light.default};
  border-radius: 10px;
  padding: 25px;
  text-align: center;
`;

export const ValuesCardImage = styled.img`
  margin: auto;
  width: 150px;
  height: 120px;
  object-fit: contain;
`;

export const ValuesCardTitle = styled.div`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color.blue.default};
  ${responsiveFontSize(24, 1)}
  margin-bottom: 15px;
`;

export const ValuesSeparatorTop = styled.img`
  bottom: 99%;
  font-size: 0;
  left: 0;
  position: absolute;
  width: 100%;
`;

export const ValuesSeparatorBottom = styled(ValuesSeparatorTop)`
  bottom: auto;
  top: 99%;
`;

export const SolutionWrapper = styled.div`
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  margin: 150px auto;
  padding: 30px;
  border-radius: 15px;
  position: relative;
  text-align: center;
  max-width: 1100px;

  ${mediaQuery('medium')} {
    /* padding: 0px;
    box-shadow: none;
    background: transparent; */
    margin: 75px auto;
  }
`;

export const SolutionTitle = styled(SectionTitle)``;

export const SolutionText = styled(SectionText)`
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

export const SolutionCardContainer = styled.div`
  display: flex;
  align-items: strech;
  justify-content: center;
  ${mediaQuery('medium')} {
    flex-direction: column;
    align-items: center;
  }
`;

export const SolutionCardWrapper = styled.div`
  padding: 10px;
  padding-top: 0;
  width: ${100 / 3}%;
  ${mediaQuery('medium')} {
    width: 100%;
    max-width: 400px;
  }
`;

export const SolutionCard = styled.div`
  height: 100%;
  border-radius: 10px;
  padding: 25px;
  text-align: center;
`;

export const SolutionCardImage = styled.img`
  margin: auto;
  width: 80px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 15px;
`;

export const SolutionCardTitle = styled.div`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color.purple.default};
  ${responsiveFontSize(24, 1)};
  margin-bottom: 15px;
  height: 100px;
  ${mediaQuery('medium')} {
    height: auto;
  }
`;

export const SocialsWrapper = styled.div`
  margin-top: 100px;
  padding-bottom: 50px;
`;
